import React from 'react';
import { Link } from 'react-router-dom';

/* Demo page. It used to sign every visitor in as a seeded account whose
 * password was in this file — an account that was an owner of a real agency,
 * so anyone could browse that agency's data. Until a demo runs on its own
 * sample-data agency, a demo is arranged by email instead. */

const DEMO_REQUEST = 'mailto:support@travelminds.com?subject=Marketing%20Portal%20demo';

const Demo: React.FC = () => {
  return (
    <>
      <section className="text-center px-4 sm:px-6 pt-8 sm:pt-12 pb-12 sm:pb-16 max-w-4xl mx-auto">
        <h1
          className="text-5xl sm:text-6xl md:text-7xl font-bold text-[var(--text)] leading-[1.05] tracking-tight mb-6"
          style={{ fontFamily: "'Quicksand', sans-serif" }}
        >
          See the portal<br />in action.
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-[var(--text-muted)] leading-relaxed max-w-2xl mx-auto">
          We&rsquo;ll walk you through the live product — campaigns, contacts,
          segments, analytics — on sample data. Ask for a demo and we&rsquo;ll set one up.
        </p>
      </section>

      <section className="px-4 sm:px-6 pb-12">
        <div className="max-w-3xl mx-auto bg-white border border-[var(--border)] rounded-xl p-8">
          <h2 className="text-xl font-semibold text-[var(--text)] mb-4">What you'll see</h2>
          <ul className="space-y-3 text-sm text-[var(--text)]">
            {[
              'A populated agency account with contacts, segments, tags and campaigns.',
              'The branded email builder with realistic layouts and merge tags.',
              'The analytics surface — opens, clicks, bounces — over time.',
              'Switching between agencies, as a multi-agency team would.',
            ].map((line) => (
              <li key={line} className="flex gap-2">
                <span className="text-[var(--accent)]">✓</span>
                <span>{line}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="px-4 sm:px-6 pb-16 text-center">
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={DEMO_REQUEST}
            className="bg-[var(--primary)] text-white px-7 py-3.5 rounded-lg font-semibold text-base hover:bg-[var(--primary-light)] transition-colors shadow-sm"
          >
            Request a demo
          </a>
          <Link
            to="/signup"
            className="bg-white border border-[var(--border)] text-[var(--text)] px-7 py-3.5 rounded-lg font-semibold text-base hover:border-[var(--primary)] hover:text-[var(--primary)] transition-colors"
          >
            Register your own
          </Link>
        </div>
        <p className="text-xs text-[var(--text-muted)] mt-4 max-w-md mx-auto">
          Or email support@travelminds.com and we&rsquo;ll find a time.
        </p>
      </section>
    </>
  );
};

export default Demo;
